import {
  GET_N8N_WORKFLOW,
  GET_N8N_WORKFLOW_SUCCESS,
  GET_N8N_WORKFLOW_FAILURE,
  LIST_N8N_WORKFLOWS,
  LIST_N8N_WORKFLOWS_SUCCESS,
  LIST_N8N_WORKFLOWS_FAILURE,
  CREATE_N8N_WORKFLOW,
  CREATE_N8N_WORKFLOW_SUCCESS,
  CREATE_N8N_WORKFLOW_FAILURE,
  UPDATE_N8N_WORKFLOW,
  UPDATE_N8N_WORKFLOW_SUCCESS,
  UPDATE_N8N_WORKFLOW_FAILURE,
  DELETE_N8N_WORKFLOW,
  DELETE_N8N_WORKFLOW_SUCCESS,
  DELETE_N8N_WORKFLOW_FAILURE,
  EXECUTE_N8N_WORKFLOW,
  EXECUTE_N8N_WORKFLOW_SUCCESS,
  EXECUTE_N8N_WORKFLOW_FAILURE,
  LIST_N8N_CLOUD_WORKFLOWS_SUCCESS,
  LIST_N8N_CLOUD_WORKFLOWS_FAILURE,
  LIST_N8N_CLOUD_WORKFLOWS_REQUEST,
} from "../actions/n8nWorkflowActions";

const initialState = {
  workflows: [],
  currentWorkflow: null,
  executionResult: null,
  loading: false,
  error: null,
  cloudWorkflows: [],
};

const n8nWorkflowReducer = (state = initialState, action) => {
  switch (action.type) {
    // Loading states
    case GET_N8N_WORKFLOW:
    case LIST_N8N_WORKFLOWS:
    case CREATE_N8N_WORKFLOW:
    case UPDATE_N8N_WORKFLOW:
    case DELETE_N8N_WORKFLOW:
    case EXECUTE_N8N_WORKFLOW:
    case LIST_N8N_CLOUD_WORKFLOWS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    // Success states
    case GET_N8N_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        currentWorkflow: action.payload,
        error: null,
      };

    case LIST_N8N_WORKFLOWS_SUCCESS:
      return {
        ...state,
        loading: false,
        workflows: action.payload,
        error: null,
      };

    case CREATE_N8N_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        workflows: [...state.workflows, action.payload],
        currentWorkflow: action.payload,
        error: null,
      };

    case UPDATE_N8N_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        workflows: state.workflows.map((workflow) =>
          workflow.id === action.payload.id ? action.payload : workflow
        ),
        currentWorkflow: action.payload,
        error: null,
      };

    case DELETE_N8N_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        workflows: state.workflows.filter(
          (workflow) => workflow.id !== action.payload.id
        ),
        currentWorkflow: null,
        error: null,
      };

    case EXECUTE_N8N_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        executionResult: action.payload,
        error: null,
      };

    case LIST_N8N_CLOUD_WORKFLOWS_SUCCESS:
      return {
        ...state,
        cloudWorkflows: action.payload,
        error: null,
        loading: false,
      };

    // Failure states
    case GET_N8N_WORKFLOW_FAILURE:
    case LIST_N8N_WORKFLOWS_FAILURE:
    case CREATE_N8N_WORKFLOW_FAILURE:
    case UPDATE_N8N_WORKFLOW_FAILURE:
    case DELETE_N8N_WORKFLOW_FAILURE:
    case EXECUTE_N8N_WORKFLOW_FAILURE:
    case LIST_N8N_CLOUD_WORKFLOWS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default n8nWorkflowReducer;
